export interface IActionContext {
  scope: ng.IScope;
  targetElement?: JQuery;
}

export module ActionContext {

  /**
   * Creates an ActionContext from a JQuery event, for example, from a button with a click
   * listener. The returned target element is that on which the event was defined, and the
   * returned scope is that of the target element.
   */
  export function fromEvent($event: JQueryEventObject): IActionContext {

    // Using $event.currentTarget rather than $event.target causes the ActionContext to be
    // attached to the element on which the listener is defined, rather than the element that was
    // clicked (which is likely a child of the element with the listener).
    const targetElement = angular.element($event.currentTarget);
    return {
      scope: targetElement.scope(),
      targetElement: targetElement
    };
  }

}
